// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circulation-container {
  margin-bottom: 20px;
}

.circulation-container:last-child {
  margin: unset;
}

.circulation-container p {
  color: #323232;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.circulation-container__caption {
  display: flex;
  justify-content: space-between;
}

.circulation-container__informations {
  display: grid;
  gap: 80px;
  grid-template-columns: repeat(5, 1fr);
  padding-top: 16px;
}

.circulation-container__information {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.circulation-container__information span {
  color: #323232;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.circulation-container__information span:nth-child(2) {
  font-size: 16px;
  font-weight: 500;
}

.circulation-container__information-blue {
  color: #24A3FF !important;
}

.circulation-container__information-red {
  color: #FF0009 !important;
}

.circulation-container__information-blur {
  filter: blur(5px);
}

.circulation-container__buttons a {
  display: inline-block;
  padding: 10px 24px;
  border-radius: 8px;
  background: #FF0009;
  color: #F6F6F6;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.circulation-container__buttons a:hover {
  color: #F6F6F6;
}

@media only screen and (max-width: 991px) {
  .circulation-container__informations {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

@media only screen and (max-width: 575px) {
  .circulation-container__caption {
    flex-direction: column;
  }
  .circulation-container__buttons {
    align-self: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/circulations/components/Circulation.scss","webpack://./src/modules/circulations/components/Circulation.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;ACCrB;;ADFA;EAII,aAAa;ACEjB;;ADNA;EAQI,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;ACEvB;;ADCE;EAGC,aAAA;EAGQ,8BAAM;ACEjB;;AAEA;EAEE,aAAa;EDAb,SAAA;EAEE,qCAAsB;EACtB,iBAAQ;ACEZ;;ADLG;EAQG,aAAY;ECMR,sBAAsB;EDd7B,QAAA;ACgBH;;AAEA;EACE,cAAc;EDDZ,eAAA;EACE,kBAAO;EACR,gBAAA;ECGH,mBAAmB;ADDjB;;ACIJ;EACE,eAAe;EDDb,gBAAA;ACGJ;;AAEA;EDAG,yBAAA;ACEH;;AAEA;EDCM,yBAAmB;ACCzB;;AAEA;EDEM,iBAAgB;ACCtB;;AAEA;EDbG,qBAAA;EAcK,kBAAc;EACf,kBAAA;ECEL,mBAAmB;EDGrB,cAAY;EAER,kBAAA;ECFF,eDGI;ECFJ,kBDGa;ECFb,gBDGG;ECFH,mBAAmB;AACrB;;AAEA;EACE,cDKI;ACJN;;AAEA;EACE;IAEM,qCAAqC;IACzC,SAAS;EACX;AACF;;AAEA;EACE;IAIU,sBAAsB;EAChC;EACA;IAGM,kBAAkB;EACxB;AACF","sourcesContent":[".circulation-container {\n  margin-bottom: 20px;\n\n  &:last-child {\n    margin: unset;\n  }\n\n  p {\n    color: #323232;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  &__caption {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  &__informations {\n    display: grid;\n    gap: 80px;\n    grid-template-columns: repeat(5, 1fr);\n    padding-top: 16px;\n  }\n\n  &__information {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    span {\n      color: #323232;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n\n      &:nth-child(2) {\n        font-size: 16px;\n        font-weight: 500;\n      }\n    }\n\n    &-blue {\n      color: #24A3FF !important;\n    }\n\n    &-red {\n      color: #FF0009 !important;\n    }\n\n    &-blur {\n      filter: blur(5px);\n    }\n  }\n\n  &__buttons {\n    a {\n      display: inline-block;\n      padding: 10px 24px;\n      border-radius: 8px;\n      background: #FF0009;\n      color: #F6F6F6;\n      text-align: center;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n\n      &:hover {\n        color: #F6F6F6;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .circulation-container {\n    &__informations {\n      grid-template-columns: repeat(2, 1fr);\n      gap: 16px;\n    }\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .circulation-container {\n    &__caption {\n      flex-direction: column;\n    }\n\n    &__buttons {\n      align-self: center;\n    }\n  }\n}",".circulation-container {\n  margin-bottom: 20px;\n}\n\n.circulation-container:last-child {\n  margin: unset;\n}\n\n.circulation-container p {\n  color: #323232;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.circulation-container__caption {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.circulation-container__informations {\n  display: -ms-grid;\n  display: grid;\n  gap: 80px;\n  -ms-grid-columns: (1fr)[5];\n      grid-template-columns: repeat(5, 1fr);\n  padding-top: 16px;\n}\n\n.circulation-container__information {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 8px;\n}\n\n.circulation-container__information span {\n  color: #323232;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.circulation-container__information span:nth-child(2) {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.circulation-container__information-blue {\n  color: #24A3FF !important;\n}\n\n.circulation-container__information-red {\n  color: #FF0009 !important;\n}\n\n.circulation-container__information-blur {\n  -webkit-filter: blur(5px);\n          filter: blur(5px);\n}\n\n.circulation-container__buttons a {\n  display: inline-block;\n  padding: 10px 24px;\n  border-radius: 8px;\n  background: #FF0009;\n  color: #F6F6F6;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.circulation-container__buttons a:hover {\n  color: #F6F6F6;\n}\n\n@media only screen and (max-width: 991px) {\n  .circulation-container__informations {\n    -ms-grid-columns: (1fr)[2];\n        grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .circulation-container__caption {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n  }\n  .circulation-container__buttons {\n    -ms-flex-item-align: center;\n        -ms-grid-row-align: center;\n        align-self: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
